import styled from 'styled-components';
import { device } from '../../../styles/devices';
import { SYS_SIZE_FIXED_250, SYS_SIZE_FIXED_600 } from '@oneaudi/unified-web-common';

interface StyleProps {
  finalRow?: boolean;
}

export const Wrapper = styled.div`
  display: flex;

  @media ${device.tablet} {
    padding: 60px;
    align-items: center;
    justify-content: center;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: 'Audi Type';
  @media ${device.tablet} {
    flex-grow: 0;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  border-bottom: 1px solid #ccc;
  ${({ finalRow }: StyleProps) => finalRow && 'margin-bottom: 50px;'};
  @media ${device.tablet} {
    flex-wrap: nowrap;
    border-top: none;
    border-bottom: none;
  }
`;

export const HeaderRow = styled(Row)`
  width: 100%;
  border-bottom: 2px solid black;
  @media ${device.tablet} {
    flex-wrap: nowrap;
    border-top: none;
    border-bottom: none;
  }
`;

export const SpecWrapper = styled.div`
  display: flex;
  width: 100%;
  border-top: none;
  @media ${device.tablet} {
    min-width: 230px;
    margin-right: 10px;
    width: auto;
    border-top: 2px solid #000000;
  }
`;

export const SpecBodyWrapper = styled.div`
  padding: ${SYS_SIZE_FIXED_250} 0 ${SYS_SIZE_FIXED_600} 0;
  width: 100%;
  @media ${device.tablet} {
    flex-grow: 1;
    border-top: 1px solid #ccc;
    ${({ finalRow }: StyleProps) => finalRow && 'border-bottom: 1px solid #ccc'};
`;
